<template>
  <div class="record-file container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入视频节点名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        ref="tree"
        :data="treeData"
        :props="defaultTreeProps"
        node-key="key"
        highlight-current
        :default-expanded-keys="treeExpandedKeys"
        :expand-on-click-node="false"
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"
               :class="data.type === 'region' ? 'tree-node-icon-region'
               : streamNodeIconClassFromStreamObjectKindAndState(data.streamObjectKind, data.alarmState, data.eventTypeSet, 0)"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
    </app-tree-side>
    <!--表格数据-->
    <div class="col-2">
      <el-form ref="queryForm" class="pagination-table-query-form" :inline="true" @keyup.enter.native="handleFormQuery()">
        <el-form-item label="录像类型">
          <el-select v-model="tableQueryParams.recordFileType" placeholder="请选择录像类型">
            <el-option v-for="(item, index) in $type.recordFileTypes"
                       :key="'fileType' + index"
                       :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事件类型">
          <el-select v-model="tableQueryParams.recordFileEventType" :disabled="tableQueryParams.recordFileType != 2" placeholder="请选择事件类型">
            <el-option v-for="(item, index) in $type.recordFileEventTypes"
                       :key="'eventType' + index"
                       :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录像时间">
          <uni-date-range-picker
            v-model="dates"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </uni-date-range-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleFormQuery()" type="primary">查 询</el-button>
          <el-button @click="resetQueryForm()">重 置</el-button>
        </el-form-item>
      </el-form>
      <div class="pagination-table-button-container">
        <el-button type="primary" @click="handleLock(null,1)" :disabled="!tableSelectedIds.length">批量加锁</el-button>
        <el-button type="primary" @click="handleLock(null,0)" :disabled="!tableSelectedIds.length">批量解锁</el-button>
        <el-button type="primary" @click="handleDownload" :disabled="!tableSelectedIds.length">批量下载</el-button>
      </div>
      <div class="pagination-table-container">
        <el-table :data="tableData"
                  ref="table"
                  v-loading="loading"
                  border element-loading-background="rgba(255, 255, 255, 0.8)"
                  element-loading-spinner="el-icon-loading"
                  element-loading-text="努力加载中..."
                  style="width: 100%"
                  @selection-change="handleTableSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column label="序号" type="index" width="60"></el-table-column>
          <el-table-column label="名称" prop="name" :show-overflow-tooltip="true"></el-table-column>
<!--          <el-table-column :show-overflow-tooltip="true" label="节点名称" prop="streamNodeId">-->
<!--            <template slot-scope="scope"> {{getNameById(scope.row.streamNodeId, treeData)}}</template>-->
<!--          </el-table-column>-->
          <el-table-column label="开始时间" prop="recordBeginDateTime" width="160">
            <template slot-scope="scope"> {{strDateTimeFromMsTime_t(scope.row.recordBeginDateTime)}}</template>
          </el-table-column>
          <el-table-column label="结束时间" prop="recordEndDateTime" width="160">
            <template slot-scope="scope"> {{strDateTimeFromMsTime_t(scope.row.recordEndDateTime)}}</template>
          </el-table-column>
          <el-table-column label="文件大小(MB)" prop="recordFileSize" width="80">
            <template slot-scope="scope">{{ mByteFromByte(scope.row.recordFileSize) }}</template>
          </el-table-column>
          <el-table-column label="服务器名称" prop="serverId" :show-overflow-tooltip="true" width="120">
            <template slot-scope="scope"> {{getNameById(scope.row.serverId, $globalData.servers)}}</template>
          </el-table-column>
          <el-table-column label="录像类型" prop="recordFileType" width="80">
            <template slot-scope="scope"> {{scope.row.recordFileType === 0 ? '未知' : getNameById(scope.row.recordFileType, $type.recordFileTypes)}}</template>
          </el-table-column>
          <el-table-column label="事件类型" prop="recordFileEventType" width="80">
            <template slot-scope="scope"> {{getNameById(scope.row.recordFileEventType, $type.recordFileEventTypes)}}</template>
          </el-table-column>
          <el-table-column label="本地路径" prop="localPath" :show-overflow-tooltip="true" width="120"></el-table-column>
          <el-table-column label="锁定标志" prop="locked" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.locked === 1 ? 'danger'
                  : 'primary'">
                {{scope.row.locked === 1 ? '锁定' : '未锁定'}}
              </el-tag>
            </template>
          </el-table-column>
<!--          <el-table-column label="锁定时长(秒)" prop="lockDuration" width="80">-->
<!--            <template slot-scope="scope">{{scope.row.lockDuration > 0 ? scope.row.lockDuration:'不限'}}</template>-->
<!--          </el-table-column>-->
<!--          <el-table-column label="锁定时间" prop="lockDateTime" width="140">-->
<!--            <template slot-scope="scope"> {{strDateTimeFromMsTime_t(scope.row.lockDateTime)}}</template>-->
<!--          </el-table-column>-->
          <el-table-column label="操作" width="130">
            <template slot-scope="scope">
              <el-button
                @click="handleLock(scope.row, scope.row.locked === 1 ? 0 : 1)"
                class="col-btn"
                :icon="scope.row.locked === 1 ? 'el-icon-unlock' : 'el-icon-lock'"
                type="text"
              >
                {{scope.row.locked === 1 ? '解锁':'锁定'}}
              </el-button>
              <el-button
                @click="handleDownload(scope.row)"
                class="col-btn"
                icon="el-icon-download"
                type="text"
              >下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentPageChange"
          @size-change="handlePageSizeChange"
          :current-page.sync="tableQueryParams.pageNum"
          :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
          :page-size.sync="tableQueryParams.pageSize"
          prev-text="上一页"
          next-text="下一页"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableTotalRow">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import RecordRecord from './RecordRecord.js'
export default RecordRecord
</script>

<style lang="scss">
// @import "RecordRecord.scss";
</style>



// WEBPACK FOOTER //
// src/views/system/recordRecord/RecordRecord.vue